import {
    selectors as bookmakersListSelectors,
} from '../common/bookmakersList'
import {
    selectors as bookmakersInfoSelectors,
} from '../common/bookmakersInfo'
import {
    selectors as userInfoSelectors,
} from '../common/userInfo'

// eslint-disable-next-line import/prefer-default-export
export const getEssentialBettingState = (store) => {
    const state = store.getState()
    const selectedBookmaker = state.bookmakersInfo.selectedBookmaker
    const feedSelector = () => selectedBookmaker
    const isUserLoggedIn = bookmakersListSelectors
            .createIsLoggedInSelector(feedSelector)(state)
    const selectedBets = state.bookmakersInfo.selectedBets
    const apiName = bookmakersListSelectors
            .createBookmakerApiNameSelector(feedSelector)(state);
    const bookmaker = state.bookmakersList.find(bookie => bookie.feed === selectedBookmaker)
    const userInfo = userInfoSelectors.createUserInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    )(state)

    return {
        isUserLoggedIn,
        selectedBets,
        apiName,
        feed: selectedBookmaker,
        isExternalLogout: !!bookmaker.isExternalLogout || null,
        currencySign: userInfo.currencySign,
    }
}



// WEBPACK FOOTER //
// /src/js/App/helpers.js